export const API_REACT_URL_FROM_SERVER = "http://localhost:3000";
export const API_REACT_URL_FROM_CLIENT = "https://www.datezone.com";
